import React from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import Trans from 'components/Common/Translation/Trans';
import Button from 'components/UI/Buttons/Button/Button';
import { getRoutesUri } from 'services/generic';

import styles from './FormSwitcher.module.scss';

type Props = {
  active: 'login' | 'create';
  isCheckout?: boolean;
};

export default function FormSwitcher({
  active,
  isCheckout = false,
}: Props): JSX.Element {
  const navigate = useNavigate();

  function goTo(itemName: Props['active'], uri: string) {
    itemName !== active && navigate(uri);
  }

  return (
    <div className={styles.formSwitchButtons}>
      <Button
        onClick={() =>
          goTo(
            'login',
            isCheckout
              ? getRoutesUri<string>('checkoutLogin')
              : getRoutesUri<string>('customerLogin')
          )
        }
        className={classNames(styles.button, {
          [styles.active]: 'login' === active,
        })}
      >
        <Trans i18nKey={'SWITCH_BUTTON_LOGIN'} namespace={'loginPage'} />
      </Button>
      <Button
        onClick={() =>
          goTo(
            'create',
            isCheckout
              ? getRoutesUri<string>('checkoutSignup')
              : getRoutesUri<string>('customerSignup')
          )
        }
        className={classNames(styles.button, {
          [styles.active]: 'create' === active,
        })}
      >
        <Trans i18nKey={'SWITCH_BUTTON_SIGNUP'} namespace={'loginPage'} />
      </Button>
    </div>
  );
}
